import styled from 'styled-components';
import { BdsGrid, BdsIllustration } from 'blip-ds/dist/blip-ds-react';
import colors from '_colors.module.scss';

export const Container = styled(BdsGrid)`
  height: 456px;
  border: 1px solid ${colors.Border2};
  border-radius: 16px;
`;

export const Illustration = styled(BdsIllustration)`
  mix-blend-mode: luminosity;
  opacity: 50%;
  width: 120px;
`;

export const Subtitle = styled.div`
  bds-typo {
    color: ${colors.ContentDisable};
  }
`;
